/**
 * Announcement API สำหรับ user-modern — เรียก tenant-management announcements
 */
import {
  fetchActiveAnnouncementsCached,
  invalidateAnnouncementCache,
  type Announcement,
} from '@huay/shared/tenantManagementPublicClient'

export type AnnouncementPriority = 'urgent' | 'general' | 'warning'
export type { Announcement }

function getAnnouncementsBaseURL(): string {
  const base = import.meta.env.VITE_API_BASE_URL
  if (base !== undefined && base !== '') return base
  if (typeof window !== 'undefined') return ''
  return 'http://localhost:8081'
}

export const announcementService = {
  async getActive(
    tenantId: string,
    username?: string | null,
    options?: { bypassCache?: boolean }
  ): Promise<{ success: boolean; data: Announcement[] }> {
    return fetchActiveAnnouncementsCached(
      getAnnouncementsBaseURL(),
      tenantId,
      'user-modern',
      username,
      options
    )
  },

  invalidateCache(tenantId: string, username?: string | null): void {
    invalidateAnnouncementCache(tenantId, 'user-modern', username)
  },

  async acknowledge(
    announcementId: string,
    tenantId: string,
    payload?: { userId?: string; sessionId?: string; clientFingerprint?: string }
  ): Promise<{ success: boolean }> {
    const base = getAnnouncementsBaseURL()
    const path = `/api/v1/tenant-management/announcements/${announcementId}/ack`
    const url = base ? `${base.replace(/\/$/, '')}${path}` : path
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Tenant-ID': tenantId },
      body: JSON.stringify({ tenantId, target: 'user-modern', ...payload }),
    })
    const json = await res.json()
    return json as { success: boolean }
  },
}
